export const LearnData = {
    data() {
        return {}
    },
    methods: {
        GetTypeData(obj) {
            return new Promise((resolve, reject) => {
                this.$request({
                    url: '/api/v1/question_type',
                    params:
                        obj && obj.data
                            ? {
                                  ...obj.data
                              }
                            : null
                })
                    .then(res => {
                        if (!res.status) {
                            resolve(res.data)
                        } else {
                            this.$message.error(res.message || '操作失败')
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }
    }
}
